import React from "react";
import { Autocomplete, TextField, createFilterOptions } from "@mui/material";
import { useTranslation } from "react-i18next";
import { mandatory } from "../../../../../../utils/Functions";

const filter = createFilterOptions();

export default function SearchableAutocomplete({
  options,
  value,
  onChange,
  label,
  required = false,
  error = false,
  helperText = "",
  size = "small",
  maxLength,
  testId,
}) {
  const { t } = useTranslation();
  const counterText = maxLength ? `${(value || "").length}/${maxLength}` : undefined;

  return (
    <Autocomplete
      freeSolo
      selectOnFocus
      handleHomeEndKeys
      size={size}
      options={options}
      value={value || ""}
      inputValue={value || ""}
      onChange={(event, newValue) => {
        if (typeof newValue === "string") {
          onChange(newValue.slice(0, maxLength));
        } else if (newValue?.inputValue) {
          onChange(newValue.inputValue.slice(0, maxLength));
        } else {
          onChange("");
        }
      }}
      onInputChange={(event, newInputValue) => {
        onChange(newInputValue.slice(0, maxLength));
      }}
      filterOptions={(currentOptions, params) => {
        const filtered = filter(currentOptions, params);
        const inputValue = params.inputValue.trim();
        const alreadyExists = currentOptions.some(
          (option) => option.toLowerCase() === inputValue.toLowerCase(),
        );
        if (inputValue !== "" && !alreadyExists) {
          filtered.push({
            inputValue,
            label: `${t("AddNewValue")} "${inputValue}"`,
          });
        }
        return filtered;
      }}
      getOptionLabel={(option) => {
        if (typeof option === "string") return option;
        return option.inputValue ?? option.label ?? "";
      }}
      isOptionEqualToValue={(option, val) => option === val}
      renderOption={(props, option) => {
        const { key, ...rest } = props;
        return (
          <li
            key={typeof option === "string" ? option : option.inputValue}
            {...rest}
            data-testid={testId && `${testId}.option`}
          >
            {typeof option === "string" ? option : option.label}
          </li>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={required ? mandatory(t(label)) : t(label)}
          error={error}
          helperText={helperText || counterText}
          fullWidth
          inputProps={{
            ...params.inputProps,
            maxLength,
            "data-testid": testId && `${testId}-input`,
          }}
        />
      )}
    />
  );
}